import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { FileIndex } from '@wdx/clmi/clmi-swagger-gen';
import {
    FileUploadPackage,
    FileUploadStatus,
} from '@wdx/shared/infrastructure/file-io';
import { Observable } from 'rxjs';
import { BaseInputClass } from '../../../../../classes/base-input-class';
import { UploaderType } from '../../../../../models/uploader-type.model';
import * as rootReducer from '../../../../../state/_setup/reducers';
import * as fileUploadActions from '../../../../../state/avatar-file-upload/avatar-file-upload.actions';
import * as fileUploadSelectors from '../../../../../state/avatar-file-upload/avatar-file-upload.selectors';
import * as partiesActions from '../../../../../state/parties/parties.actions';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'molecule-input-contact-avatar-upload',
    templateUrl: './molecule-input-contact-avatar-upload.component.html',
    standalone: false,
})
export class MoleculeInputContactAvatarUploadComponent
    extends BaseInputClass
    implements OnInit
{
    @Input() uploadType: UploaderType;
    @Input() partyId: string;

    fileUploadStatus$: Observable<FileUploadStatus>;
    fileUploadProgress$: Observable<number>;
    fileIndex$: Observable<FileIndex>;
    fileUrl$: Observable<string>;

    valueFileIndex: FileIndex;

    constructor(
        actions$: Actions,
        elementRef: ElementRef,
        store$: Store<rootReducer.State>,
    ) {
        super();

        this.patchInjectedItems({
            actions$,
            elementRef,
            store$,
        });
    }

    ngOnInit() {
        this.listenTo(fileUploadActions.uploadFileComplete).subscribe(() => {
            // reload avatar image
            this.store$.dispatch(
                partiesActions.getForId({ partyId: this.partyId }),
            );
        });
    }

    onFileAdded(fileUploadPackage: FileUploadPackage): void {
        if (!this.partyId) {
            return;
        }

        this.store$.dispatch(
            fileUploadActions.uploadFile({
                id: fileUploadPackage.id,
                partyId: this.partyId,
                file: fileUploadPackage.file,
            }),
        );

        this.fileUploadStatus$ = this.store$.select(
            fileUploadSelectors.getFileUploadStatus,
            { id: fileUploadPackage.id },
        );
        this.fileUploadProgress$ = this.store$.select(
            fileUploadSelectors.getFileUploadProgress,
            { id: fileUploadPackage.id },
        );
        this.fileIndex$ = this.store$.select(
            fileUploadSelectors.getFileUploadFileIndex,
            { id: fileUploadPackage.id },
        );
    }

    onRemoveFile(fileUploadPackage: FileUploadPackage) {
        this.onClear();

        if (fileUploadPackage) {
            this.store$.dispatch(
                fileUploadActions.uploadFileReset({ id: fileUploadPackage.id }),
            );
        }
    }
}
